module.exports = __webpack_public_path__ + "static/media/hilux-mk8-extra-cab.c463d305.jpg";